module.exports = __webpack_public_path__ + "static/media/shop_header.638cfa49.png";